import React from 'react';
import { clsx } from 'clsx';
import type { DashboardControl, TimeRangeConfig } from '@/types/dashboard';

interface PeriodOption {
  label: string;
  start_date: string;
  end_date: string;
}

interface PeriodToggleControlProps {
  control: DashboardControl;
  currentValue: unknown;
  onChange: (parameterKey: string, value: unknown) => void;
}

const PeriodToggleControl: React.FC<PeriodToggleControlProps> = ({
  control,
  currentValue,
  onChange,
}) => {
  const periods = (control.config.periods as PeriodOption[] | undefined) ?? [];

  if (periods.length === 0) {
    return (
      <div className="px-3 py-1.5 text-xs text-muted-foreground italic">
        {control.label}: No periods configured
      </div>
    );
  }

  const currentRange = currentValue as TimeRangeConfig | null;
  const selectedIdx = currentRange
    ? periods.findIndex(
        (p) =>
          p.start_date === currentRange.start_date &&
          p.end_date === currentRange.end_date
      )
    : -1;

  const handleSelect = (period: PeriodOption) => {
    const config: TimeRangeConfig = {
      type: 'specific_range',
      start_date: period.start_date,
      end_date: period.end_date,
    };
    onChange(control.parameter_key, config);
  };

  return (
    <div className="flex items-center gap-0.5 p-0.5 rounded-lg bg-muted border border-border">
      {periods.map((period, idx) => (
        <button
          key={`${period.start_date}-${period.end_date}`}
          onClick={() => handleSelect(period)}
          className={clsx(
            'px-3 py-1 rounded-md text-sm font-medium transition-all',
            idx === selectedIdx
              ? 'bg-card text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          )}
        >
          {period.label}
        </button>
      ))}
    </div>
  );
};

export default PeriodToggleControl;
